import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { forwardRef, useContext, useEffect, useRef, useState } from 'react';
import CustomSelect2 from './CustomSelect2';
import { Box, Typography, FormControlLabel, Grid, TextField, InputAdornment, Button, IconButton, Select, MenuItem, colors, Checkbox, Skeleton } from '@mui/material';
import SelectPlanCheckbox from './SelectPlanCheckbox';
import { ConfigContext } from '../utils/ConfigContext';
import TableRatesRow from './TableRatesRow';
import getSafe from '../utils/getSafe';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import domtoimage from 'dom-to-image';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PercentInput from './PercentInput';
import NotesDisplay from './NotesDisplay';
import RatesVersionSelect from './RatesVersionSelect';
import CopyImageButton from './CopyImageButton';
import CopyExcelDataButton from './CopyExcelDataButton';


const MorganPrice_Rates = forwardRef(({ appConfig, sx, clients, loadingStatus, currency, selectedPlans, setSelectedPlans,
  response, deductibles, setDeductibles, addToPendingTasks,
  discounts, setDiscounts, computedRates, setComputedRates,
  specificAreaOfCoverage, setSpecificAreaOfCoverage, areaOfCoverage,
  setShowImageCopy, selectedOptions, addSelectedOption,
  setViewSelectedOption, specificCurrency, setSpecificCurrency,
  specificPaymentFrequency, setSpecificPaymentFrequency,
  morganPriceSpecific, setMorganPriceSpecific, loadings, setLoadings , insurerRates = [], selectedRatesVersion, setSelectedRatesVersion, handleFetchAppConfig, setShowRefreshNow }, ref) => {
  // const { appConfig } = useContext(ConfigContext);

  const id = 'morgan_price';

  const excess_in_patient_treatment = getSafe(() => appConfig.content.specifics.morgan_price.excess_in_patient_treatment);
  const payment_frequency_rates = getSafe(() => appConfig.content.specifics.morgan_price.payment_frequency_rates);
  const area_of_coverages = getSafe(() => appConfig.content.specifics.morgan_price.area_of_coverages, []);

  const [excessInPatientTreatment, setExcessInPatientTreatment] = useState(excess_in_patient_treatment ? getExcessInPatientTreatmentsLabel()[0] : '');

  const plans = ['vumi_basic', 'vumi_standard', 'vumi_superior', 'vumi_ultra', 'vumi_total'];

  const specific_area_of_coverages = getSafe(() => appConfig.content.morgan_price_area_of_coverage);

  const currencies = getSafe(() => appConfig.content.currencies, []);


  const [optionalCovers, setOptionalCovers] = useState({
    op_module_1: false,
    op_module_2: false,
    remove_op_co_insurance: false,
    reduce_overall_annual_limit: false,
    dental: false,
    maternity_module: false,
    enhanced_network_module: false,
  });

  // const tableRowRef = useRef(null);
  // const [maxHeight, setMaxHeight] = useState(0);

  // useEffect(() => {
  //   const parentTable = tableRowRef.current.closest('table');

  //   if (parentTable) {
  //     // Select all TableRow elements inside the TableBody
  //     const rows = document.querySelectorAll('#' + parentTable.id + ' .MuiTableBody-root .MuiTableRow-root');

  //     // Calculate the maximum height
  //     let max = 0;
  //     rows.forEach(row => {
  //       const height = row.offsetHeight;
  //       if (height > max) {
  //         max = height;
  //       }
  //     });

  //     setMaxHeight(max);
  //   }
  // }, [response, optionalCovers]);


  useEffect(() => {
    computedRates[id] = getComputedRates();
    setComputedRates(computedRates);

  }, [response, discounts, loadings, excessInPatientTreatment, selectedPlans]);

  useEffect(() => {
    setTimeout(() => {
      addSelectedOption(id, 'excess_inpatient_treatment', excessInPatientTreatment);
      addSelectedOption(id, 'specific_area_of_coverage', specificAreaOfCoverage[id]);
      addSelectedOption(id, 'specific_currency', specificCurrency[id]);
      addSelectedOption(id, 'specific_payment_frequency', specificPaymentFrequency[id]);
      addSelectedOption(id, 'discount', discounts[id] == '' ? 0 : discounts[id]);
      addSelectedOption(id, 'loading', loadings[id] == '' ? 0 : loadings[id]);
    }, 1000);
  }, [excessInPatientTreatment, specificAreaOfCoverage[id], specificCurrency[id], specificPaymentFrequency[id], discounts[id]]);

  useEffect(() => {
    setViewSelectedOption(id, 'excess_inpatient_treatment', setExcessInPatientTreatment);

    setViewSelectedOption(id, 'excess_inpatient_treatment', (option_value) => {
      morganPriceSpecific['excess_in_patient_treatment'] = option_value;
      setMorganPriceSpecific({ ...morganPriceSpecific });
    });

    setViewSelectedOption(id, 'discount', (option_value) => {
      discounts[id] = option_value;
      setDiscounts(discounts);
    });

    setViewSelectedOption(id, 'loading', (option_value) => {
      loadings[id] = option_value;
      setDiscounts(loadings);
    });

    setViewSelectedOption(id, 'specific_area_of_coverage', (option_value) => {
      specificAreaOfCoverage[id] = option_value;
      setSpecificAreaOfCoverage(specificAreaOfCoverage);
    });

    setViewSelectedOption(id, 'specific_currency', (option_value) => {
      specificCurrency[id] = option_value;
      setSpecificCurrency(specificCurrency);
    });

    setViewSelectedOption(id, 'specific_payment_frequency', (option_value) => {
      specificPaymentFrequency[id] = option_value;
      setSpecificPaymentFrequency(specificPaymentFrequency);
    });
  }, [selectedOptions]);

  // useEffect(() => {
  //   const newSelectedPlans = selectedPlans.filter(selectedPlan => {
  //     return selectedPlan !== 'morgan_price_core_ip' || selectedPlan !== 'morgan_price_core_op1' || selectedPlan !== 'morgan_price_core_op2';
  //   });

  //   console.log('1', newSelectedPlans);

  //   if (!selectedOptions.op_module_1 && !selectedOptions.op_module_2) {
  //     newSelectedPlans.push('morgan_price_core_ip');
  //   } else if (selectedOptions.op_module_1 && !selectedOptions.op_module_2) {
  //     newSelectedPlans.push('morgan_price_core_op1');
  //   } else if (!selectedOptions.op_module_1 && selectedOptions.op_module_2) {
  //     newSelectedPlans.push('morgan_price_core_op2');
  //   }

  //   console.log('2', newSelectedPlans);

  //   setSelectedPlans(newSelectedPlans);
  // }, [selectedOptions]);


  // function updateSelectedPlans() {
  //   const newSelectedPlans = selectedPlans.filter(selectedPlan => {
  //     return selectedPlan !== 'morgan_price_core_ip' && selectedPlan !== 'morgan_price_core_op1' && selectedPlan !== 'morgan_price_core_op2';
  //   });

  //   console.log('1', newSelectedPlans);

  //   newSelectedPlans.push('morgan_price_core_ip');

  //   if (optionalCovers.op_module_1 && !optionalCovers.op_module_2) {
  //     newSelectedPlans.push('morgan_price_core_op1');
  //   } else if (!optionalCovers.op_module_1 && optionalCovers.op_module_2) {
  //     newSelectedPlans.push('morgan_price_core_op2');
  //   }

  //   console.log('2', newSelectedPlans);

  //   setSelectedPlans([...newSelectedPlans]);
  // }


  function getComputedRates() {
    if (!response) return;

    const rates = response.rates;
    const discount = discounts[id];
    const loading = parseFloat(loadings[id]) || 0;
    const totalPercent = (100 - discount + loading) * 0.01;

    const excess_rate = excess_in_patient_treatment[excessInPatientTreatment];

    let payment_frequency = specificPaymentFrequency[id];

    const payment_frequency_rate = payment_frequency_rates[payment_frequency];
    const paymentFrequencyDivide = getPaymentFrequencyDivided(payment_frequency);

    // total *= payment_frequency_rate;

    // total /= paymentFrequencyDivide;

    const computedRates = [];



    for (let i = 0; i < rates.length; i++) {
      let core_ip = computeSubtotalRate('core_ip', rates[i]);
      let core_op1 = computeSubtotalRate('core_op1', rates[i]);
      let core_op2 = computeSubtotalRate('core_op2', rates[i]);

      // // excess discount
      // core_ip *= excess_rate;
      // core_op1 *= excess_rate;
      // core_op2 *= excess_rate;

      // // payment frequency surcharge
      // core_ip *= payment_frequency_rate;
      // core_op1 *= payment_frequency_rate;
      // core_op2 *= payment_frequency_rate;

      // // payment frequency divide
      // core_ip /= paymentFrequencyDivide;
      // core_op1 /= paymentFrequencyDivide;
      // core_op2 /= paymentFrequencyDivide;

      // custom discount
      core_ip *= totalPercent;
      core_op1 *= totalPercent;
      core_op2 *= totalPercent;

      computedRates.push({
        'client': rates[i].client,
        'currency': rates[i].currency,
        'core_ip': core_ip,
        'core_op1': core_op1,
        'core_op2': core_op2,
        'plan_label': getPlanLabel()
      });
    }

    return computedRates;
  }

  function computeSubtotalPerPlan(plan) {
    const computedRates = getComputedRates();

    if (!computedRates) {
      return 0;
    }

    let total = 0;

    for (let i = 0; i < computedRates.length; i++) {
      total += computedRates[i][plan];
    }

    return total;
  }

  function computeSubtotalPerClient(plan, index) {
    const computedRates = getComputedRates();

    if (!computedRates) {
      return 0;
    }

    if (!computedRates[index]) {
      return 0;
    }


    return computedRates[index][plan];
  }

  function computeSubtotalRate(plan, rate) {
    let total = computedRate(rate.core_ip, specificPaymentFrequency[id]);

    if (plan === 'core_op1') {
      total += computedRate(rate.op_module_1, specificPaymentFrequency[id]);
    }

    if (plan === 'core_op2') {
      total += computedRate(rate.op_module_2, specificPaymentFrequency[id]);
    }

    if (selectedPlans.includes('morgan_price_remove_op_co_insurance')) {
      total += computedRate(rate.remove_op_co_insurance, specificPaymentFrequency[id]);
    }

    if (selectedPlans.includes('morgan_price_reduce_overall_annual_limit')) {
      total += computedRate(rate.reduce_overall_annual_limit, specificPaymentFrequency[id]);
    }

    if (selectedPlans.includes('morgan_price_dental')) {
      total += computedRate(rate.dental, specificPaymentFrequency[id]);
    }

    if (selectedPlans.includes('morgan_price_maternity_module')) {
      total += computedRate(rate.maternity_module, specificPaymentFrequency[id]);
    }

    if (selectedPlans.includes('morgan_price_enhanced_network_module')) {
      total += computedRate(rate.enhanced_network_module, specificPaymentFrequency[id]);
    }

    if (selectedPlans.includes('morgan_price_increase_si')) {
      total += computedRate(rate.increase_si, specificPaymentFrequency[id]);
    }

    return total;
  }

  function getPlanLabel() {
    let label = 'Core';

    if (selectedPlans.includes('morgan_price_core_op1')) {
      label += ' + OP1';
    }

    if (selectedPlans.includes('morgan_price_core_op2')) {
      label += ' + OP2';
    }

    // if (optionalCovers.remove_op_co_insurance) {
    //   label += ' + OP Co-Insurance';
    // }

    // if (optionalCovers.reduce_overall_annual_limit) {
    //   label += ' + Reduce SI';
    // }

    // if (optionalCovers.dental) {
    //   label += ' + Dental';
    // }

    // if (optionalCovers.maternity_module) {
    //   label += ' + Maternity Module';
    // }

    // if (optionalCovers.enhanced_network_module) {
    //   label += ' + Enhanced Network Module';
    // }

    return label;
  }


  function checkIfThereIsAnySelectedPlan() {
    for (let i = 0; i < selectedPlans.length; i++) {
      if (plans.includes(selectedPlans[i])) {
        return true;
      }
    }

    return false;
  }

  function getExcessInPatientTreatmentsLabel() {
    const labels = [];

    for (let key in excess_in_patient_treatment) {
      labels.push(key);
    }

    return labels;
  }

  function computeMorganPriceRates(rates) {
    const computedRates = [];

    for (let i = 0; i < rates.length; i++) {
      computedRates.push({
        'client': rates[i].client,
        'currency': rates[i].currency,
        'core_ip': computedRate(rates[i].core_ip, specificPaymentFrequency[id]),
        'op_module_1': computedRate(rates[i].op_module_1, specificPaymentFrequency[id]),
        'op_module_2': computedRate(rates[i].op_module_2, specificPaymentFrequency[id]),
        'remove_op_co_insurance': computedRate(rates[i].remove_op_co_insurance, specificPaymentFrequency[id]),
        'reduce_overall_annual_limit': computedRate(rates[i].reduce_overall_annual_limit, specificPaymentFrequency[id]),
        'dental': computedRate(rates[i].dental, specificPaymentFrequency[id]),
        'maternity_module': computedRate(rates[i].maternity_module, specificPaymentFrequency[id]),
        'enhanced_network_module': computedRate(rates[i].enhanced_network_module, specificPaymentFrequency[id]),
        'increase_si': computedRate(rates[i].increase_si, specificPaymentFrequency[id]),
      })
    }

    return computedRates;
  }

  function computeTotalPerClient(rates, index) {
    if (!response) return;

    if (!response.rates[index]) return;

    let total = 0;

    const core_ip = rates[index].core_ip;
    const op_module_1 = rates[index].op_module_1;
    const op_module_2 = rates[index].op_module_2;
    const remove_op_co_insurance = rates[index].remove_op_co_insurance;
    const reduce_overall_annual_limit = rates[index].reduce_overall_annual_limit;
    const dental = rates[index].dental;
    const maternity_module = rates[index].maternity_module;
    const enhanced_network_module = rates[index].enhanced_network_module;
    const increase_si = rates[index].increase_si;

    let arrayRatesObjects = [
      { name: 'core_ip', value: core_ip },
      { name: 'op_module_1', value: op_module_1 },
      { name: 'op_module_2', value: op_module_2 },
      { name: 'remove_op_co_insurance', value: remove_op_co_insurance },
      { name: 'reduce_overall_annual_limit', value: reduce_overall_annual_limit },
      { name: 'dental', value: dental },
      { name: 'maternity_module', value: maternity_module },
      { name: 'enhanced_network_module', value: enhanced_network_module },
      { name: 'increase_si', value: increase_si }
    ];

    arrayRatesObjects.forEach(arrRate => {
      if (arrRate.name === 'core_ip') {
        if (!(arrRate.value === 'Unavailable' || typeof arrRate.value === 'string')) {
          total += arrRate.value;
        }
      } else if (optionalCovers[arrRate.name]) {
        if (!(arrRate.value === 'Unavailable' || typeof arrRate.value === 'string')) {
          total += arrRate.value;
        }
      }
    });

    const discount = discounts[id];
    const totalPercent = (100 - discount) * 0.01;

    return total * totalPercent;
  }

  function computeGrandTotal() {
    if (!response) return;

    // if (!response.rates[index]) return;

    let total = 0;

    const rates = response ? computeMorganPriceRates(response.rates) : [];

    for (let i = 0; i < clients.length; i++) {
      total += computeTotalPerClient(rates, i);
    }

    return total;
  }

  function computedRate(rate, payment_frequency) {
    if (rate === 'Unavailable' || typeof rate === 'string') {
      return rate;
    }


    // const currency = specificCurrency[id];

    // if (currency !== 'USD') {
    //   return 'Unavailable';
    // }

    /*
    let total = rate;

    const excess_rate = excess_in_patient_treatment[excessInPatientTreatment];

    total *= excess_rate;

    const payment_frequency_rate = payment_frequency_rates[payment_frequency];
    const paymentFrequencyDivide = getPaymentFrequencyDivided(payment_frequency);

    total *= payment_frequency_rate;

    total /= paymentFrequencyDivide;

    return total;
    */


    return rate;
  }

  function computeExcessDiscount() {
    const computedRates = getComputedRates();

    if (!computedRates) {
      return 0;
    }

  }

  function getPaymentFrequencyDivided(payment_frequency) {
    if (payment_frequency === 'Monthly') {
      return 12;
    } else if (payment_frequency === 'Quarterly') {
      return 4;
    } else if (payment_frequency === 'Semi Annually') {
      return 2;
    } else if (payment_frequency === 'Annually') {
      return 1;
    }

    return 1;
  }

  function onInputDiscountChange(e) {
    let value = e.target.value;

    // Allow only numbers and at most one decimal point
    value = value.replace(/[^0-9.]/g, '');

    // Prevent multiple decimals
    if ((value.match(/\./g) || []).length > 1) {
      value = value.substring(0, value.lastIndexOf('.'));
    }

    // Ensure only two decimal places
    if (value.includes('.')) {
      const [integerPart, decimalPart] = value.split('.');
      value = `${integerPart}.${decimalPart.substring(0, 2)}`;
    }

    // Remove leading zeros (but allow "0" or "0.x" scenarios)
    if (value !== '' && value !== '0' && value.startsWith('0') && !value.startsWith('0.')) {
      value = value.replace(/^0+/, '');
    }

    // Limit value to a maximum of 100
    if (parseFloat(value) > 100) {
      value = '100';
    }

    discounts[id] = value;

    setDiscounts({ ...discounts });
  }

  function getAreaOfCoverageKey(area_of_coverage) {
    // let key = '';

    for (var key in area_of_coverages) {
      if (area_of_coverage === area_of_coverages[key]) {
        return key;
      }
    }

    return '';
  }

  function formatRate(rate) {
    if (isNaN(rate) || rate == 'Unavailable' || typeof rate === 'string') {
      return <span style={{ color: '#f44336' }}>{'Unavailable'}</span>
    }

    if (isNaN(rate)) {
      return rate;
    }

    return getCurrencySign() + rate.toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function getCurrencySign() {
    const currency = specificCurrency[id];

    if (currency === 'USD') {
      return '$';
    } else if (currency === 'EURO') {
      return '€';
    } else if (currency === 'GBP') {
      return '£';
    } else if (currency === 'SGD') {
      return 'S$';
    }

    return '';
  }

  return (
    <Box id={id} sx={sx}>
      <Paper sx={{ borderColor: '#e0e0e0', borderWidth: 2, pb: 2 }} variant='outlined'>

        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#0f7ac0', px: 2, py: 1 }}>
          <div style={{
            color: '#fff',
            backgroundColor: '#0e54b1',
            width: 100,
            height: 60,
            padding: 6,
            fontFamily: 'Poppins, sans-serif',
            fontSize: 13,
            lineHeight: 1.2,
          }}>Flexible Choices Asia</div>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <img
              src={`${process.env.PUBLIC_URL}/images/mp-international-01.svg`}
              alt="Morgan Price International"
              style={{ height: 20, filter: 'brightness(0) invert(1)', userSelect: 'none', WebkitUserDrag: 'none' }}
              draggable={false}
              onContextMenu={(e) => e.preventDefault()}
            />
          </Box>
        </Box>
        <Box sx={{ p: 2 }}>

          <Box sx={{ display: 'flex', gap: 5 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography fontSize={15} fontWeight={600}>Plan Type</Typography>
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='morgan_price_core_ip' />} label="Core" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='morgan_price_core_op1' />} label="Core + OP1" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='morgan_price_core_op2' />} label="Core + OP2" />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography fontSize={15} fontWeight={600}>Optional Cover</Typography>
              {/* <FormControlLabel control={<Checkbox checked={optionalCovers.op_module_1}
                onChange={(e) => {
                  let checked1 = e.target.checked;
                  let checked2;

                  if (checked1) {
                    checked2 = false;
                  } else {
                    checked1 = false;
                    checked2 = false;
                  }

                  setOptionalCovers({ ...optionalCovers, op_module_1: checked1, op_module_2: checked2 });

                  // updateSelectedPlans();
                }
                } />}
                label="OP Module 1" />
              <FormControlLabel control={<Checkbox checked={optionalCovers.op_module_2}
                onChange={(e) => {
                  let checked1 = e.target.checked;
                  let checked2;

                  if (checked1) {
                    checked2 = false;
                  } else {
                    checked1 = false;
                    checked2 = false;
                  }

                  setOptionalCovers({ ...optionalCovers, op_module_2: checked1, op_module_1: checked2 });

                  // updateSelectedPlans();
                }
                } />}
                label="OP Module 2" /> */}
              {/* <FormControlLabel control={<Checkbox checked={optionalCovers.remove_op_co_insurance}
                onChange={(e) => { setOptionalCovers({ ...optionalCovers, remove_op_co_insurance: e.target.checked }) }} />}
                label="OP Co-Insurance" />
              <FormControlLabel control={<Checkbox checked={optionalCovers.reduce_overall_annual_limit}
                onChange={(e) => { setOptionalCovers({ ...optionalCovers, reduce_overall_annual_limit: e.target.checked }) }} />}
                label="Reduce SI" />
              <FormControlLabel control={<Checkbox checked={optionalCovers.dental}
                onChange={(e) => { setOptionalCovers({ ...optionalCovers, dental: e.target.checked }) }} />}
                label="Dental" />
              <FormControlLabel control={<Checkbox checked={optionalCovers.maternity_module}
                onChange={(e) => { setOptionalCovers({ ...optionalCovers, maternity_module: e.target.checked }) }} />}
                label="Maternity Module" />
              <FormControlLabel control={<Checkbox checked={optionalCovers.enhanced_network_module}
                onChange={(e) => { setOptionalCovers({ ...optionalCovers, enhanced_network_module: e.target.checked }) }} />}
                label="Enhanced Network Module" /> */}

              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='morgan_price_remove_op_co_insurance' />} label="OP Co-Insurance" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='morgan_price_reduce_overall_annual_limit' />} label="Reduce SI" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='morgan_price_dental' />} label="Dental" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='morgan_price_maternity_module' />} label="Maternity Module" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='morgan_price_enhanced_network_module' />} label="Enhanced Network Module" />
              <FormControlLabel sx={{ mb: 0, '& .MuiFormControlLabel-label': { fontSize: 13 } }} control={<SelectPlanCheckbox size="small" selectedPlans={selectedPlans} setSelectedPlans={setSelectedPlans} planId='morgan_price_increase_si' />} label="Increase SI" />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', minHeight: 40 }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Area</Typography>
                <Select
                  size='small'
                  value={specificAreaOfCoverage[id]}
                  onChange={(e) => {
                    specificAreaOfCoverage[id] = e.target.value;
                    setSpecificAreaOfCoverage({ ...specificAreaOfCoverage });

                    addToPendingTasks([id]);
                  }}
                  sx={{ fontSize: 12, height: 32, width: '170px', minWidth: 170 }}
                  fullWidth
                  disabled={loadingStatus[id]}
                >
                  {/* <MenuItem value={'parent'} sx={{ color: colors.blue[500] }}>{areaOfCoverage}</MenuItem> */}
                  {
                    specific_area_of_coverages && specific_area_of_coverages.map(area_of_coverage => (
                      <MenuItem key={area_of_coverage} value={area_of_coverage} sx={{ fontSize: 12 }}>{getAreaOfCoverageKey(area_of_coverage)}</MenuItem>
                    ))
                  }
                </Select>

              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', minHeight: 40 }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Area of Coverage</Typography>
                <Typography sx={{ maxWidth: 200, fontSize: 12 }}>{specificAreaOfCoverage[id]}</Typography>
              </Box>

              {/* <Box sx={{ display: 'flex', alignItems: 'start' }}>
                <Typography fontSize={18} fontWeight={600} sx={{ width: 200 }}>Currency</Typography>
                <Select
                  size='small'
                  value={specificCurrency[id]}
                  onChange={(e) => {
                    specificCurrency[id] = e.target.value;
                    setSpecificCurrency({ ...specificCurrency });

                    setDeductibles(prev => {
                      return {
                        ...prev,
                        [id]: 'Nil Deductible'
                      };
                    });


                    addToPendingTasks([id]);
                  }}
                  sx={{ fontSize: 12, height: 40, width: '190px', minWidth: 190 }}
                  fullWidth
                  disabled={loadingStatus[id]}
                >
                  {
                    currencies && currencies.map(currency => (
                      <MenuItem key={currency} value={currency}>{currency}</MenuItem>
                    ))
                  }

                </Select>
              </Box> */}

              <Box sx={{ display: 'flex', alignItems: 'center', minHeight: 40 }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Payment Frequency</Typography>
                <Select
                  size='small'
                  value={specificPaymentFrequency[id]}
                  onChange={(e) => {
                    specificPaymentFrequency[id] = e.target.value;
                    setSpecificPaymentFrequency({ ...specificPaymentFrequency });

                    addToPendingTasks([id]);
                  }}
                  sx={{ fontSize: 12, height: 32, width: '170px', minWidth: 170 }}
                  fullWidth
                  disabled={loadingStatus[id]}
                >
                  {
                    ["Annually", "Semi Annually", "Quarterly", "Monthly"].map(payment_frequency => (
                      <MenuItem key={payment_frequency} value={payment_frequency} sx={{ fontSize: 12 }}>{payment_frequency}</MenuItem>
                    ))
                  }

                </Select>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', minHeight: 40 }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Excess applicable to In-Patient treatment</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <CustomSelect2
                    dense
                    sx={{ minWidth: 170 }}
                    value={excessInPatientTreatment}
                    onChange={(e) => {
                      setExcessInPatientTreatment(e.target.value);

                      morganPriceSpecific['excess_in_patient_treatment'] = e.target.value;
                      setMorganPriceSpecific(morganPriceSpecific);

                      addToPendingTasks([id]);
                    }}
                    items={getExcessInPatientTreatmentsLabel()}
                    disabled={loadingStatus[id]}
                    isZeroDeductibleUniform={false}
                  />
                </Box>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Renewal/Further Discount</Typography>
                <PercentInput
                  value={discounts[id]}
                  onCommit={(value) => setDiscounts(prev => ({ ...prev, [id]: value }))}
                />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography fontSize={13} fontWeight={600} sx={{ width: 170 }}>Renewal/Further Loading</Typography>
                <PercentInput
                  value={loadings[id]}
                  onCommit={(value) => setLoadings(prev => ({ ...prev, [id]: value }))}
                />
              </Box>
            </Box>
          </Box>

          <div style={{ display: 'flex', alignItems: 'start', justifyContent: 'end', width: '100%', marginBottom: 7 }}>
            <CopyExcelDataButton
              elementId='table-morgan-price-rates'
              style={{ marginRight: 7, fontSize: 11, padding: '2px 8px', minHeight: 0 }}
              sx={{ '& .MuiSvgIcon-root': { fontSize: 14 } }}
            />
            <CopyImageButton
              elementId='table-morgan-price-rates'
              setShowImageCopy={setShowImageCopy}
              style={{ fontSize: 11, padding: '2px 8px', minHeight: 0 }}
              sx={{ '& .MuiSvgIcon-root': { fontSize: 14 } }}
            />
          </div>

          <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
            <Table id='table-morgan-price-rates' size='small' sx={{ minWidth: 650, background: '#fff', width: `calc(100% + ${clients.length > 5 ? clients.length - 5 : 0} * 75px)` }}>
              <TableHead>
                <TableRow style={{ background: '#0f7ac0', color: '#fff' }}>
                  <TableCell style={{ width: 250, color: '#fff', fontWeight: 600 }}>Plan</TableCell>
                  {
                    clients.map((client, idx) => {
                      if (client.full_name.trim() === '') {
                        return <TableCell style={{ width: 200, fontWeight: 600, color: '#fff' }} key={idx}>_</TableCell>
                      }

                      return <TableCell style={{ width: 200, color: '#fff', fontWeight: 600 }} key={idx}><div>{client.full_name} ({client.age})</div><div>{client.country_of_residence}</div></TableCell>
                    })
                  }
                  <TableCell style={{ color: '#fff', fontWeight: 600 }}>Subtotal</TableCell>
                </TableRow>

              </TableHead>
              <TableBody>
                <TableRatesRow
                  planId='morgan_price_core_ip'
                  planName='core_ip'
                  planLabel='Core IP'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? computeMorganPriceRates(response.rates) : []}
                  currency={currency}
                  discount={discounts[id]}
                  additionalLoading={loadings[id]}
                  visible={selectedPlans.includes('morgan_price_core_ip') || selectedPlans.includes('morgan_price_core_op1') || selectedPlans.includes('morgan_price_core_op2')}
                  labelWidth={250}
                />
                <TableRatesRow
                  planId='morgan_price_op_module_1'
                  planName='op_module_1'
                  planLabel='OP Module 1'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? computeMorganPriceRates(response.rates) : []}
                  currency={currency}
                  discount={discounts[id]}
                  additionalLoading={loadings[id]}
                  visible={selectedPlans.includes('morgan_price_core_op1')}
                  labelWidth={250}
                />
                <TableRatesRow
                  planId='morgan_price_op_module_2'
                  planName='op_module_2'
                  planLabel='OP Module 2'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? computeMorganPriceRates(response.rates) : []}
                  currency={currency}
                  discount={discounts[id]}
                  additionalLoading={loadings[id]}
                  visible={selectedPlans.includes('morgan_price_core_op2')}
                  labelWidth={250}
                />
                <TableRatesRow
                  planId='morgan_price_remove_op_co_insurance'
                  planName='remove_op_co_insurance'
                  planLabel='OP Co-Insurance'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? computeMorganPriceRates(response.rates) : []}
                  currency={currency}
                  discount={discounts[id]}
                  additionalLoading={loadings[id]}
                  visible={selectedPlans.includes('morgan_price_remove_op_co_insurance')}
                  labelWidth={250}
                />
                <TableRatesRow
                  planId='morgan_price_reduce_overall_annual_limit'
                  planName='reduce_overall_annual_limit'
                  planLabel='Reduce SI'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? computeMorganPriceRates(response.rates) : []}
                  currency={currency}
                  discount={discounts[id]}
                  additionalLoading={loadings[id]}
                  visible={selectedPlans.includes('morgan_price_reduce_overall_annual_limit')}
                  labelWidth={250}
                />
                <TableRatesRow
                  planId='morgan_price_dental'
                  planName='dental'
                  planLabel='Dental'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? computeMorganPriceRates(response.rates) : []}
                  currency={currency}
                  discount={discounts[id]}
                  additionalLoading={loadings[id]}
                  visible={selectedPlans.includes('morgan_price_dental')}
                  labelWidth={250}
                />
                <TableRatesRow
                  planId='morgan_price_maternity_module'
                  planName='maternity_module'
                  planLabel='Maternity Module'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? computeMorganPriceRates(response.rates) : []}
                  currency={currency}
                  discount={discounts[id]}
                  additionalLoading={loadings[id]}
                  visible={selectedPlans.includes('morgan_price_maternity_module')}
                  labelWidth={250}
                />
                <TableRatesRow
                  planId='morgan_price_enhanced_network_module'
                  planName='enhanced_network_module'
                  planLabel='Enhanced Network Module'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? computeMorganPriceRates(response.rates) : []}
                  currency={currency}
                  discount={discounts[id]}
                  additionalLoading={loadings[id]}
                  visible={selectedPlans.includes('morgan_price_enhanced_network_module')}
                  labelWidth={250}
                />
                <TableRatesRow
                  planId='morgan_price_increase_si'
                  planName='increase_si'
                  planLabel='Increase SI'
                  clients={clients}
                  selectedPlans={selectedPlans}
                  loading={loadingStatus[id]}
                  rates={response ? computeMorganPriceRates(response.rates) : []}
                  currency={currency}
                  discount={discounts[id]}
                  additionalLoading={loadings[id]}
                  visible={selectedPlans.includes('morgan_price_increase_si')}
                  labelWidth={250}
                />
                {
                  selectedPlans.includes('morgan_price_core_ip') &&
                  <TableRow style={{ backgroundColor: '#ffffff' }}>
                    <TableCell style={{ border: '2px solid #fff', fontWeight: 600, background: '#bdbdbd' }}>Core Total Premium</TableCell>
                    {
                      clients.map((client, idx) => {
                        return <TableCell style={{ border: '2px solid #fff', background: '#bdbdbd' }} key={idx}> {loadingStatus[id] ? <Skeleton variant="rounded" width={100} height={20} /> : formatRate(computeSubtotalPerClient('core_ip', idx))}</TableCell>
                      })
                    }
                    <TableCell style={{ border: '2px solid #fff', background: '#bdbdbd' }}>{loadingStatus[id] ? <Skeleton variant="rounded" width={100} height={20} /> : formatRate(computeSubtotalPerPlan('core_ip'))}</TableCell>
                  </TableRow>
                }

                {
                  selectedPlans.includes('morgan_price_core_op1') &&
                  <TableRow style={{ backgroundColor: '#ffffff' }}>
                    <TableCell style={{ border: '2px solid #fff', fontWeight: 600, background: '#bdbdbd' }}>Core + OP1 Total Premium</TableCell>
                    {
                      clients.map((client, idx) => {
                        return <TableCell style={{ border: '2px solid #fff', background: '#bdbdbd' }} key={idx}> {loadingStatus[id] ? <Skeleton variant="rounded" width={100} height={20} /> : formatRate(computeSubtotalPerClient('core_op1', idx))}</TableCell>
                      })
                    }
                    <TableCell style={{ border: '2px solid #fff', background: '#bdbdbd' }}>{loadingStatus[id] ? <Skeleton variant="rounded" width={100} height={20} /> : formatRate(computeSubtotalPerPlan('core_op1'))}</TableCell>
                  </TableRow>
                }

                {
                  selectedPlans.includes('morgan_price_core_op2') &&
                  <TableRow style={{ backgroundColor: '#ffffff' }}>
                    <TableCell style={{ border: '2px solid #fff', fontWeight: 600, background: '#bdbdbd' }}>Core + OP2 Total Premium</TableCell>
                    {
                      clients.map((client, idx) => {
                        return <TableCell style={{ border: '2px solid #fff', background: '#bdbdbd' }} key={idx}> {loadingStatus[id] ? <Skeleton variant="rounded" width={100} height={20} /> : formatRate(computeSubtotalPerClient('core_op2', idx))}</TableCell>
                      })
                    }
                    <TableCell style={{ border: '2px solid #fff', background: '#bdbdbd' }}>{loadingStatus[id] ? <Skeleton variant="rounded" width={100} height={20} /> : formatRate(computeSubtotalPerPlan('core_op2'))}</TableCell>
                  </TableRow>

                }

              </TableBody>
            </Table>

          </TableContainer>

          <NotesDisplay appConfig={appConfig} insurerId={id} />

          <RatesVersionSelect
            insurer={id}
            label="Rates Version"
            insurerRates={insurerRates}
            selectedRatesVersion={selectedRatesVersion}
            setSelectedRatesVersion={setSelectedRatesVersion}
            disabled={loadingStatus[id]}
            handleFetchAppConfig={handleFetchAppConfig}
            onChange={() => setShowRefreshNow(true)}
          />
        </Box>


      </Paper>

    </Box>
  );
});

export default MorganPrice_Rates;